import { FilterCollectionStore, RemoteCollectionStore, SortCollectionStore, StoreBuilder } from "@softline/core";
import { PmsMeldung } from "../types/pms-meldung";

export const PmsMeldungenStore = new StoreBuilder(RemoteCollectionStore.create<PmsMeldung>())
    .add(FilterCollectionStore.create<PmsMeldung>())
    .add(SortCollectionStore.create<PmsMeldung>())
    .value;